import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-governance-path',
  templateUrl: './governance-path.component.html',
  styleUrls: ['./governance-path.component.sass']
})
export class GovernancePathComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
